























import { Component, Vue } from 'vue-property-decorator';
import NavigationBar from './components/navigation/NavigationBar.vue';
import FooterSection from './components/FooterSection.vue';
import { Theme } from './store';
import { IModalInitData } from './entities';
// modals
const ModalSolution = () => import('./components/modal/solution/ModalSolution.vue');
const ModalConsultation = () => import('./components/modal/consultation/ModalConsultation.vue');
const ModalService = () => import('./components/modal/service/ModalService.vue');
const ModalPlan = () => import('./components/modal/plan/ModalPlan.vue');
const ModalPlanPublic = () => import('./components/modal/plan-public/ModalPlanPublic.vue');
const ModalOrderItemContact = () => import('./components/modal/common/ModalOrderItemContact.vue');
const ModalPaymentResult = () => import('./components/modal/payment/ModalPaymentResult.vue');
const ModalCertificate = () => import('./components/modal/certificate/ModalCertificate.vue');

@Component({
  components: {
    NavigationBar,
    FooterSection, 
    ModalSolution,
    ModalConsultation,
    ModalService,
    ModalPlan,
    ModalPlanPublic,
    ModalOrderItemContact,
    ModalPaymentResult,
    ModalCertificate,
  },
  metaInfo(): Object {
    return {
      titleTemplate: '%s' + this.$storage.getters.getPlatformInfo()?.name
    }
  }
})
export default class App extends Vue {

  get theme(): Theme {
    return this.$store.state.theme;
  }
  get theming(): boolean {
    return this.$store.state.theming;
  }
  get themeClass(): string {
    let theme = this.theme
    return this.theming ? (theme ? ('theme-' + theme) : '') : '';
  }

  get modal(): IModalInitData {
    return this.$store.state.modal;
  }

  get modalName(): string {
    return this.modal?.name || '';
  }

  get modalKey(): string {
    let source = this.modal?.from;
    let id = this.modal?.subject?.id;

    return this.modalName + (source ? ('-' + source) : '') + (id ? ('-' + id) : '');
  }

  mounted(): void {
    this.$storage.actions.updatePlatformInfo();
  }

}
